import { FC } from 'react';
import PeriodRow, {
  PeriodRowProps,
} from 'presentation/components/modules/period/PeriodRow';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';
import IncomeChartView from 'presentation/components/modules/incomeChart/IncomeChartView';
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { Period } from 'enums/shared/period';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import ProfitText from 'presentation/components/shared/amount/ProfitText';

interface Props extends PeriodRowProps {
  isDataFetching: boolean;
  error?: FetchBaseQueryError | SerializedError;
  onRefetch: () => void;
  period: Period;
  data: PortfolioChartData;
}

const IncomeChartLoaded: FC<Props> = ({
  onPeriodClick,
  selectedPeriod,
  isDataFetching,
  error,
  onRefetch,
  period,
  data,
}) => {
  const chartHeight = 300;

  const currencyText = useCurrencyText();

  let chartContent;
  if (isDataFetching) {
    chartContent = (
      <Center height={chartHeight}>
        <Spinner />
      </Center>
    );
  } else if (error) {
    chartContent = (
      <Center height={chartHeight}>
        <ErrorContainer error={error} onRetry={onRefetch} />
      </Center>
    );
  } else {
    chartContent = (
      <IncomeChartView
        chartData={data.chartData}
        currency={data.currency}
        chartHeight={chartHeight}
        period={period}
      />
    );
  }

  return (
    <Box w="100%" h="100%">
      <Flex alignItems="center" flexWrap="wrap">
        <Text fontSize="30px" fontWeight={700} mr="20px">
          {currencyText(data.balance, { symbol: data.currency.symbol })}
        </Text>
        <ProfitText
          profitAmount={data.balanceChange}
          profitPercent={data.balanceChangePercent}
          currency={data.currency}
          fontSize="24px"
          fontWeight={700}
        />
      </Flex>
      {chartContent}
      <Box h="20px"/>
      <PeriodRow
        onPeriodClick={onPeriodClick}
        selectedPeriod={selectedPeriod}
      />
    </Box>
  );
};

export default IncomeChartLoaded;
